module.exports = __webpack_public_path__ + "static/media/osiomole.7bd9f97b.JPG";